<app-moment icon="settings" [title]="momentData.eventTitle" colour="#95c2fe" [momentData]="momentData"></app-moment>
